export const TRAINING_LAUNCH_MAX_QUEUE_AGE_MS = 7 * 24 * 60 * 60 * 1000;
export const TRAINING_LAUNCH_MAX_QUEUE_AGE_SECONDS = Math.floor(
  TRAINING_LAUNCH_MAX_QUEUE_AGE_MS / 1000,
);
